import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const CITY_PATH = "/master/v1/city";

export const getCityApi = async (params) => await getRequest(CITY_PATH, params);

export const getCityByIdApi = async (id) =>
  await getRequest(`${CITY_PATH}/${id}`);

export const addCityApi = async (body) => await postRequest(CITY_PATH, body);

export const updateCityApi = async (body) =>
  await putRequest(`${CITY_PATH}/${body?._id}`, body);

export const deleteCityByIdApi = async (id) =>
  await deleteRequest(`${CITY_PATH}/${id}`);
